import { Icon, Text } from 'shared/components/ui';
import { Analytics } from 'features/analytics';
import { environment } from 'environments/environment';

import styles from './index.module.scss';

interface Props {
	text: string;
}

export const GoogleSocialButton = ({ text }: Props) => {
	const submitForm = () => {
		Analytics.trackGoogleSignInButtonClicked();
		const redirectTo = encodeURIComponent(window.location.href);
		const errorTo = encodeURIComponent(`${window.location.origin}/login-error`);
		window.location.href = `${environment.apiUrl}/login/google-oauth2?redirect_to=${redirectTo}&error_to=${errorTo}`;
	};

	return (
		<button className={styles.wrapper} onClick={submitForm}>
			<Icon className={styles.icon} icon="google-logo" size={32} />
			<Text variant="inter/16/medium" color="white">
				{text}
			</Text>
		</button>
	);
};

export const MicrosoftSocialButton = ({ text }: Props) => {
	const microsoftSubmitForm = () => {
		Analytics.trackMicrosoftSignInButtonClicked();
		const redirectTo = encodeURIComponent(window.location.href);
		const errorTo = encodeURIComponent(`${window.location.origin}/login-error`);
		window.location.href = `${environment.apiUrl}/login/microsoft-oauth2?redirect_to=${redirectTo}&error_to=${errorTo}`;
	};

	return (
		<button className={styles.wrapper} onClick={microsoftSubmitForm}>
			<Icon className={styles.icon} icon="microsoft-logo" size={32} />
			<Text variant="inter/16/medium" color="white">
				{text}
			</Text>
		</button>
	);
};
